import { z } from "zod";
import { isValidRegex } from "./is-valid-regex";
import {
  odataDefinitionSchema,
  odataOperatorSchema,
  odataPropertyFns,
  odataValueSchema,
} from "./odata";

export const filterPropertyFunctionSchema = z.enum(odataPropertyFns);

const baseFilterSchema = z.object({
  operator: odataOperatorSchema,
  value: odataValueSchema,
});

export type BaseFilter = z.infer<typeof baseFilterSchema>;

export const filterSchema = odataDefinitionSchema
  .extend(baseFilterSchema.shape)
  .extend({
    fn: filterPropertyFunctionSchema.optional(),
    isArray: z.boolean().optional(),
    ors: z.array(baseFilterSchema).optional(),
  });

export type Filter = z.infer<typeof filterSchema>;

const qsFilterSchema = filterSchema.refine(
  (input: Filter) =>
    (input.operator !== "matches" && input.operator !== "does not match") ||
    typeof input.value !== "string" ||
    isValidRegex(input.value),
  { message: "Invalid regular expression", path: ["value"] },
);

export const filtersSchema = z.array(qsFilterSchema);

export const topLevelFiltersSchema = z.object({
  endpoints: filtersSchema.optional().catch([]),
  users: filtersSchema.optional().catch([]),
  inboxes: filtersSchema.optional().catch([]),
});

export type TopLevelFilters = z.infer<typeof topLevelFiltersSchema>;
